import React, { FC } from "react";

const advancedLine: FC = () => {
    return (
        <svg viewBox="0 0 35 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V21C35 24.3137 32.3137 27 29 27H6C2.68629 27 0 24.3137 0 21V6Z"
                fill="#5FADCE"
            />
            <path
                d="M12.0985 19.928C12.0985 19.928 12.8545 20.072 13.5565 20.072C14.2585 20.072 15.0505 19.928 15.0505 19.928L15.6985 17.372H19.3165L19.9465 19.928C19.9465 19.928 20.7565 20.072 21.4585 20.072C22.1425 20.072 22.9165 19.928 22.9165 19.928L19.5505 7.472C19.5505 7.472 18.5605 7.328 17.4985 7.328C16.4185 7.328 15.4645 7.472 15.4645 7.472L12.0985 19.928ZM17.5165 9.794L18.8845 15.446H16.1125L17.5165 9.794Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(advancedLine);
